import { canv } from "@/canv/global.js";
import type { ShapeTextPart } from "@/shapeStorage/shapes/shape";
import { Shape } from "@/shapeStorage/shapes/shape";

export class ShapeMessage extends Shape {
    width = 200;
    height = 164;
    needFill = false;
    defaultColor = "transparent";
    includeText = false;

    setDrawStyle(_: any): void {}

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 7) / 8 - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + this.getTextLineHeight(textPart) + height / 1.5 - textPart.height / 2;

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(
        x: number,
        y: number,
        w: number,
        h: number,
        shapeStyles: {
            color: string;
            borderColor: string;
            borderDashType: string;
            borderWidth: number;
        },
    ) {
        const r = w > h ? (w * 15) / 200 : (h * 15) / 164;
        canv.ctx.save();
        canv.ctx.fillStyle = shapeStyles.color;
        canv.ctx.strokeStyle = shapeStyles.borderColor;
        canv.ctx.lineWidth = shapeStyles.borderWidth;
        canv.ctx.lineCap = "round";

        this.setStrokeType(
            shapeStyles.borderColor,
            shapeStyles.borderDashType,
            shapeStyles.borderWidth,
        );

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + r, y);
        canv.ctx.arcTo(x + w, y, x + w, y + h, r);
        canv.ctx.arcTo(x + w, y + h, x, y + h, r);
        canv.ctx.arcTo(x, y + h, x, y, r);
        canv.ctx.arcTo(x, y, x + w, y, r);
        canv.ctx.fill();

        canv.ctx.moveTo(x + w, y + r);
        canv.ctx.arcTo(x + w / 2, y + h / 2, x, y + r, 15);
        canv.ctx.lineTo(x, y + r);

        canv.ctx.stroke();

        canv.ctx.closePath();
        canv.ctx.restore();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path fill="${stroke}" clip-rule="evenodd" d="m20.186 3c1.5542 0 2.814 1.26639 2.814 2.82857v12.34283c0 1.5622-1.2598 2.8286-2.814 2.8286h-16.37205c-1.5541 0-2.81395-1.2664-2.81395-2.8286v-12.34283c0-1.56218 1.25985-2.82857 2.81395-2.82857zm-17.65112 15.1714c0 .7101.57266 1.2857 1.27907 1.2857h16.37205c.7065 0 1.2791-.5756 1.2791-1.2857v-9.90801l-8.0202 5.13481c-.0088.0057-.0179.0118-.0269.0171-.4292.2505-.9168.3816-1.413.3817-.4964 0-.9847-.1311-1.414-.3817-.0089-.0052-.0172-.0115-.026-.0171l-8.03012-5.13682zm1.27907-13.62854c-.70641 0-1.27907.57563-1.27907 1.28571v.60469l8.82662 5.64714c.1951.1139.4178.1737.6435.1737.2254 0 .4466-.06.6415-.1737l8.8186-5.64714v-.60469c0-.71008-.5726-1.28571-1.2791-1.28571z" fill-rule="evenodd"/>
            </svg>
        `;
    }
}
